// extracted by mini-css-extract-plugin
export default {"Upload":"Upload_Upload__L9tTX","uploadBox":"Upload_uploadBox__16VmX","uploadLabel":"Upload_uploadLabel__8lTQ8"};